import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App'; // Your main App component
import { ErrorBoundary } from './common/Custom/ErrorBoundary';
import './index.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter';

// Find the root element in your HTML
const container = document.getElementById('root');

// Ensure container is not null
if (container) {
    // Create a root for your application
    const root = createRoot(container);

    // Render your app component within the BrowserRouter
    root.render(
        <React.StrictMode>
            {/* A render crash shows ErrorPage, not a blank screen (#652). */}
            <ErrorBoundary>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ErrorBoundary>
        </React.StrictMode>
    );
} else {
    console.error('Failed to find the root element');
}
